// extracted by mini-css-extract-plugin
export default {"Modal":"RemoveUserModal_Modal__6xLnz"};